import * as pages from '@/pages'
import { Log, Router } from '@lightningjs/sdk'
import {
  getCatchupEpisode,
  getEpisode,
  getEpisodeData,
  getPlaylist,
  getPlaylists,
  getPodcastData,
  getPodcastList,
} from './api/Api'
import { isFilledObject, isObject } from './AppHelpers'
import { appSettings } from './AppSettings'
import { getBrandData, getCatchUpData } from './RouteHelpers'

let _stage = null
export default {
  stage(stage) {
    _stage = stage
  },
  async boot() {
    await appSettings.initialize(this)
  },
  // bootComponent: pages.Splash,
  root: 'radio',
  routes: [
    {
      path: 'radio',
      component: pages.Radio,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async (page, params) => {
        const { radioBrand } = params
        const historyState = params[Router.symbols['historyState']]
        await getBrandData(
          page,
          historyState && historyState.radioBrand ? historyState.radioBrand : radioBrand
        )
      },
      options: {
        clearHistory: true,
      },
    },
    {
      path: 'radio/:radioBrand',
      component: pages.Radio,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async (page, { radioBrand }, autoPlay = true) => {
        await getBrandData(page, radioBrand, autoPlay)
      },
    },
    {
      path: 'liveVideo',
      component: pages.LivePlayer,
      widgets: [],
      on: async (page, params) => {
        page.data = params.streamData
      },
      options: {
        preventStorage: true,
      },
    },
    {
      path: 'catchup',
      component: pages.CatchUp,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async (page, params) => {
        const { radioBrand } = params
        const historyState = params[Router.symbols['historyState']]
        await getCatchUpData(
          page,
          historyState && historyState.radioBrand ? historyState.radioBrand : radioBrand
        )
      },
      options: {
        clearHistory: true,
      },
    },
    {
      path: 'catchup/:radioBrand',
      component: pages.CatchUp,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async (page, { radioBrand }) => {
        if (isFilledObject(appSettings.catchUpBackState) && appSettings.catchUpBackState.brand) {
          radioBrand = appSettings.catchUpBackState.brand
        }

        await getCatchUpData(page, radioBrand)
      },
    },
    {
      path: 'playlists',
      component: pages.Playlists,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async page => {
        return getPlaylists().then(results => {
          page.items = results
        })
      },
      options: {
        clearHistory: true,
      },
    },
    {
      path: 'podcasts',
      component: pages.Podcasts,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async page => {
        return getPodcastList().then(results => {
          if (isObject(results) === false) {
            Router.navigate('errorPage', { type: 'NoData', route: 'podcasts' }, false)
          } else {
            page.items = results
          }
        })
      },
      options: {
        clearHistory: true,
      },
    },
    {
      path: 'episodes/:dataType/:brandName/:dataId',
      component: pages.Episodes,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async (page, { dataType, brandName, dataId }) => {
        return getEpisodeData(dataType, dataId).then(results => {
          if (results) {
            results.brandName = brandName
          }
          page.items = results
        })
      },
    },
    {
      path: 'catchupDetails/:chatchId/:episodeId',
      component: pages.CatchupDetail,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async (page, { chatchId, episodeId, background, autoPlay = true }) => {
        return getCatchupEpisode(chatchId, episodeId).then(results => {
          if (results) {
            results.chatchId = chatchId
            results.background = background ? background : null
          }
          page.items = results
          page.autoPlay = autoPlay
        })
      },
    },
    {
      path: 'podcasts/episodes/:episodeId',
      component: pages.EpisodeDetail,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async (page, { episodeId, autoPlay = true }) => {
        return getEpisode(episodeId).then(results => {
          page.items = results
          page.autoPlay = autoPlay
        })
      },
    },
    {
      path: 'playlistDetails/:playlistId',
      component: pages.PlaylistDetail,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async (page, { playlistId, autoPlay = true }) => {
        return getPlaylist(playlistId).then(results => {
          page.items = results
          page.autoPlay = autoPlay
        })
      },
    },
    {
      path: 'podcastDetails/:podcastId',
      component: pages.PodcastDetail,
      widgets: ['GlobalPlayer', 'SideMenu', 'ErrorBox'],
      on: async (page, { podcastId }) => {
        return getPodcastData(podcastId).then(results => {
          page.items = results
        })
      },
    },
    {
      path: 'search',
      component: pages.Search,
      widgets: ['GlobalPlayer', 'SideMenu'],
    },
    {
      path: 'settings',
      component: pages.Settings,
      widgets: ['GlobalPlayer', 'SideMenu'],
      on: async page => {
        page.items = ''
      },
      options: {
        clearHistory: true,
      },
    },
    {
      path: '$',
      component: pages.Splash,
    },
    {
      path: 'errorPage',
      component: pages.ErrorPage,
      widgets: ['GlobalPlayer'],
    },
    {
      path: '*',
      hook: () => {
        Router.navigate('errorPage', { type: 'offlineError' }, false)
      },
    },
    {
      path: '!',
      hook: () => {
        Router.navigate('errorPage', { type: 'notFoundError' }, false)
      },
    },
  ],
  beforeEachRoute: async () => {
    _stage.gc()
    Log.info('calling this.stage.gc()---')
    return true
  },
}
